import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Space,
  Spin,
  Select,
  DatePicker,
  Radio,
  Col,
  Row,
  Card,
  message,
  Popconfirm,
} from "antd";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import PageBreadcrumb from "../../component/PageBreadcrumb";
import { UTCToAsiaTimeConverter } from "../../helper/helper";
import { CancelSession, Upcoming } from "../../redux/actions/SessionAction";

const dateFormat = "YYYY-MM-DD";


const UpcomingSession = () => {
  const dispatch = useDispatch();
  var upcomingSession = useSelector((state) => state.SessionReducer.upcoming);
  const [date, setDate] = useState(moment(new Date()).format(dateFormat));
  const [sessionType, setSessionType] = useState("Regular");
  const [type, setType] = useState("");
  const [cancelSessionLoader, setCancelSessionLoader] = useState(false);

  function onPickDate(date, dateString) {
    setDate(dateString);
  }
  const onChangeSessionType = (e) => {
    setSessionType(e.target.value);
  };

  const fetchUpcomingSession = () => {
    // setLoader(true);
    var data = {
      date: date,
      type: sessionType,
      page: 1,
      limit: 200,
      timezone: "Asia/Kolkata",
    };
    if(type === "Curriculum") {
      data.isCurriculum = true
    }

    if(type === "Non-Curriculum") {
      data.nonCurriculum = true
    }

    if(type === "Peer Session") {
      data.isPeerSession = true
    }
    const onSuccess = () => {
    };
  
    const onError = () => {
    };
  
    dispatch(Upcoming(data, onSuccess, onError));
  };

  const cancelSession = (sessionId) => {
    setCancelSessionLoader(sessionId);
    const payload = {
      sessionId,
      cancelRequestedBy: "admin",
    };

    const onSuccess = (res) => {
      message.success(res);
      setCancelSessionLoader(false);
      fetchUpcomingSession();
    };

    const onError = (error) => {
      message.error(error);
      setCancelSessionLoader(false);
    };

    CancelSession(payload, onSuccess, onError);
  };

    const columns = [
        {
          title: 'Sl No',
          dataIndex: 'slNo',
          key: 'slNo',
          width: 70,
        },
        sessionType === "Regular" && {
          title: "Curriculum session",
          dataIndex: "curriculumSession",
          key: "curriculumSession",
          filters: [
            {
              text: "Curriculum Sessions",
              value: "true",
            },
            {
              text: "Normal Session",
              value: "false",
            },
          ],
          onFilter: (value, record) => record.curriculumSession.startsWith(value),
        },
        sessionType === "Regular" &&{
          title: "Session level",
          width: 180,
          dataIndex: "level",
          key: "level",
        },
        {
          title: 'Learner name',
          dataIndex: 'learnerName',
          key: 'learnerName'
        },
        sessionType === "Demo" && {
          title: 'Learner phone',
          dataIndex: 'learnerPhone',
          key: 'learnerPhone',
          width: 150,
        },
        { title: 'Teacher name', dataIndex: 'teacherName', key: 'teacherName' },
        { title: 'Type', dataIndex: 'type', key: 'type' ,
        filters: [
          {
            text: 'Demo',
            value: 'Demo',
          },
          {
            text: 'Regular',
            value: 'Regular',
          },
        ],
        onFilter: (value, record) => record.type.startsWith(value),
      },
        { title: 'User type', dataIndex: 'userType', key: 'userType' ,
        filters: [
          {
            text: 'Kid',
            value: 'Kid',
          },
          {
            text: 'Adult',
            value: 'Adult',
          },
        ],
        onFilter: (value, record) => record.userType.startsWith(value),
      },
        { 
          title: 'BDA Session', 
          dataIndex: 'isBDAsession', 
          key: 'isBDAsession',
          width: 120,
          filters: [
            {
              text: 'True',
              value: 'true',
            },
            {
              text: 'False',
              value: 'false',
            },
          ],
          onFilter: (value, record) => String(record.isBDAsession) === value,
          render: (text) => String(text === true || text === 'true'),
        },
        { title: 'Date', dataIndex: 'date', key: 'date' },
        { title: 'Time', dataIndex: 'time', key: 'time' },
        { title: 'Meeting no', dataIndex: 'meetingNo', key: 'meetingNo' },
        { title: 'Host', dataIndex: 'host', key: 'host' },
        { title: 'Password', dataIndex: 'password', key: 'password' },
        { title: 'Joining link', key: 'joiningLink',
        fixed: 'right',
        width: 130,
        render: ({joiningLink}) => <a href={joiningLink} target="_blank">Join meeting</a>
      },
        sessionType === "Demo" ? {
          title: 'Cancel',
          key: 'cancel',
          fixed: 'right',
          width: 130,
          render: ({ sessionId, isCancel }) => (
            <Popconfirm
              title="Are you sure you want to cancel this session?"
              onConfirm={() => cancelSession(sessionId)}
              okText="Yes"
              cancelText="No"
              disabled={isCancel}
            >
              <Button
                danger
                block
                loading={sessionId === cancelSessionLoader}
                disabled={isCancel}
              >
                {isCancel ? "Canceled" : "Cancel"}
              </Button>
            </Popconfirm>
          ),
        } : {
          title: 'Magic link',
          key: 'magicLink',
          fixed: 'right',
          width: 130,
          render: ({magicLink}) => <a href={magicLink} target="_blank">Magic login</a>
        },
      ].filter(Boolean);
      
      const sessionDetails = upcomingSession?.map((data,i)=>({
        key: i,
        slNo: i+1,
        sessionId: data?._id,
        isCancel: data?.isCancel,
        learnerName: data?.learner?.name,
        learnerPhone: data?.learner?.phoneNumber
          ? `${data?.learner?.countryCode || ""} ${data.learner.phoneNumber}`.trim()
          : "N/A",
        teacherName:data?.teacher?.name,
        type: data.type,
        userType: data.forKids?"Kid":"Adult",
        isBDAsession: data?.isBdaDemoSession || false,
        date: moment(new Date(data.sessionDate)).format('YYYY-MM-DD'),
        time: UTCToAsiaTimeConverter(data.startTime)+" - "+UTCToAsiaTimeConverter(data.endTime),
        meetingNo:data.meetingNo,
        host:data.host,
        password:data.meetingPassword,
        joiningLink:data.joinMeetingUrl,
        curriculumSession: data?.topic?._id?"true":"false",
        level: data?.topic?._id?
        `${data?.topic?.module?.level} level, chapter ${data?.topic?.chapter?.serialNo}, ${data?.topic?.name} `
        :"N/A",
        magicLink:data.forKids?`https://kids.clapingo.com/learner/session?id=${data?.learner?._id}`:`https://clapingo.com/upcoming_session?id=${data?.learner?._id}`
      }))
            

    return (
        <div>
            <PageBreadcrumb route={["Session", "Upcoming sessions"]} />
            <Card title="Filter Session" style={{ marginBottom: "1rem" }}>
              <Row>
                <Col span={4}>
                  <Radio.Group onChange={onChangeSessionType} value={sessionType}>
                    <Radio value={"Regular"}>Regular</Radio>
                    <Radio value={"Demo"}>Demo</Radio>
                  </Radio.Group>
                </Col>

                <Col span={20}>
                  <Space>
                    <DatePicker
                      onChange={onPickDate}
                      defaultValue={moment(new Date(), dateFormat)}
                      format={dateFormat}
                    />
                    {sessionType !== "Demo" && (
                      <>
                    <label htmlFor="sessionFilter" style={{ marginLeft:"2rem"}}>Session Filter</label>
                    <Select
                    defaultValue=""
                    style={{ width: 120 }}
                    onChange={(value) => setType(value)}
                  >
                    <option value="">All</option>
                    <option value="Curriculum">Curriculum</option>
                    <option value="Non-Curriculum">Non-Curriculum</option>
                    <option value="Peer Session">Peer Session</option>
                  </Select>
                    </>
                    )}
                    <Button
                      type="primary"
                      onClick={() => {
                        fetchUpcomingSession();
                      }}
                    >
                      Search
                    </Button>
                  </Space>
                </Col>
              </Row>
           </Card>
            {
              upcomingSession ?
              <Table 
              columns={columns} 
              dataSource={sessionDetails} 
              scroll={{ x: 1400 }} 
              pagination={false}
              />
              :
              <div className="spin-center">
                <Spin size="large" />
               </div>
            }
            
        </div>
    )
}

export default UpcomingSession
